var exhTBSUSF_1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_1.jpg';
var exhTBSUSF_2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_2.jpg';
var exhTBSUSF_3 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_3.jpg';
var exhTBSUSF_4 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_4.jpg';
var exhTBSUSF_5 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_5.jpg';
var exhTBSUSF_6 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_6.jpg';
var exhTBSUSF_7 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_7.jpg';
var exhTBSUSF_8 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_8.jpg';
var exhTBSUSF_9 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_9.jpg';
var exhTBSUSF_10 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_10.jpg';
var exhTBSUSF_11 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_11.jpg';
var exhTBSUSF_12 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_12.jpg';
var exhTBSUSF_13 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_13.jpg';
var exhTBSUSF_14 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/exhTBSUSF_14.jpg';
var exhTBSUSF_15 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition_tbsu_sf/IMG_2920.jpg';

export const allImagesDesktopOrderExhTBSUSF = [
    [/*COLUMN 1*/
        [
            {
                name: exhTBSUSF_1,
                captionln1: "The banner outside Gerald Peters Gallery in Santa Fe announcing the solo exhibition, <b>The Space Between Us</b>.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf1"
            },
        ],
        [
            {
                name: exhTBSUSF_2,
                captionln1: "Gerald Peters Gallery before the opening of the solo exhibition, <b>The Space Between Us</b>, in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf2"
            },
        ],
        [
            {
                name: exhTBSUSF_5,
                captionln1: "Gerald Peters Gallery before the opening of the solo exhibition, <b>The Space Between Us</b>, in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf5"
            },
        ],
        [
            {
                name: exhTBSUSF_4,
                captionln1: "Gerald Peters Gallery before the opening of <b>The Space Between Us</b> in Santa Fe with the short accompanying video in the background.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf4"
            },
        ],
        [
            {
                name: exhTBSUSF_3,
                captionln1: "Gerald Peters Gallery before the opening of the solo exhibition, <b>The Space Between Us</b>, in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf3"
            },
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: exhTBSUSF_6,
                captionln1: "Checking out the light on the painting, <span class='italics'>Accordion</span>, before the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf6"
            },
        ],
        [
            {
                name: exhTBSUSF_9,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf9"
            },
        ],
        [
            {
                name: exhTBSUSF_8,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf8"
            },
        ],
        [
            {
                name: exhTBSUSF_7,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf7"
            },
        ],
        [
            {
                name: exhTBSUSF_13,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf13"
            },
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: exhTBSUSF_11,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf11"
            },
        ],
        [
            {
                name: exhTBSUSF_12,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf12"
            },
        ],
        [
            {
                name: exhTBSUSF_10,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf10"
            },
        ],
        [
            {
                name: exhTBSUSF_14,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf14"
            },
        ],
        [
            {
                name: exhTBSUSF_15,
                captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
                captionln2: "",
                captionln3: "",
                link: "tbsu_sf15"
            },
        ]
    ]          
]

export const allImagesMobileOrderExhTBSUSF = [
    [{
        name: exhTBSUSF_1,
        captionln1: "The banner outside Gerald Peters Gallery in Santa Fe announcing the solo exhibition, <b>The Space Between Us</b>.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf1"
    },
    {
        name: exhTBSUSF_2,
        captionln1: "Gerald Peters Gallery before the opening of the solo exhibition, <b>The Space Between Us</b>, in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf2"
    },
    {
        name: exhTBSUSF_5,
        captionln1: "Gerald Peters Gallery before the opening of the solo exhibition, <b>The Space Between Us</b>, in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf5"
    },
    {
        name: exhTBSUSF_4,
        captionln1: "Gerald Peters Gallery before the opening of <b>The Space Between Us</b> in Santa Fe with the short accompanying video in the background.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf4"
    },
    {
        name: exhTBSUSF_3,
        captionln1: "Gerald Peters Gallery before the opening of the solo exhibition, <b>The Space Between Us</b>, in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf3"
    },
    {
        name: exhTBSUSF_6,
        captionln1: "Checking out the light on the painting, <span class='italics'>Accordion</span>, before the opening of the solo exhibition, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf6"
    },
    {
        name: exhTBSUSF_9,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf9"
    },
    {
        name: exhTBSUSF_8,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf8"
    },
    {
        name: exhTBSUSF_7,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf7"
    },
    {
        name: exhTBSUSF_13,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf13"
    },
    {
        name: exhTBSUSF_11,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf11"
    },
    {
        name: exhTBSUSF_12,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf12"
    },
    {
        name: exhTBSUSF_10,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf10"
    },
    {
        name: exhTBSUSF_14,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf14"
    },
    {
        name: exhTBSUSF_15,
        captionln1: "The opening of the solo show, <b>The Space Between Us</b>, at Gerald Peters Gallery in Santa Fe.",
        captionln2: "",
        captionln3: "",
        link: "tbsu_sf15"
    }]      
]
